import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDataContext } from "../contexts/AuthContext";
import { backofficeLogin } from "../services/api";
import waitingTermsStyles from "../styles/estilos/waitingTerms.module.css";
import logoPng from "../images/Frame.png";

// Ingreso a MCB desde el backoffice V4 (impersonación con token firmado, sin pedir DNI).
function BackofficeLogin() {
  const { token } = useParams();
  const { setToken } = useDataContext();
  const navigate = useNavigate();

  useEffect(() => {
    // Limpiar la cookie del token antes de iniciar sesión.
    document.cookie = "token=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";

    backofficeLogin({ token })
      .then((data) => {
        setToken(data.token);
        navigate("/terminos");
      })
      .catch((error) => {
        console.error("Error al ingresar desde el backoffice:", error);
      });
  }, [token]);

  return (
    <div className={waitingTermsStyles.messageContainer}>
      <img src={logoPng} alt="littleBlueLogo" className={waitingTermsStyles.img} />
      <h2 className="text-muted">INGRESANDO A MCB</h2>
      <div className={waitingTermsStyles.loader}></div>
    </div>
  );
}

export default BackofficeLogin;
